/*
auto-generated by: https://github.com/react-spring/gltfjsx
*/
import { RepeatWrapping, sRGBEncoding } from 'three';
import React, { useRef } from 'react'
import { useLoader } from 'react-three-fiber'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'

export default function Model(props) {
  const group = useRef()
  const { nodes, materials } = useLoader(GLTFLoader, '/assets/Mountain/Mountain.gltf')

  const texture = materials.Mountain_glTF.map;
  texture.repeat.set(100, 100);
  texture.wrapS = RepeatWrapping;
  texture.wrapT = RepeatWrapping;
  texture.anisotropy = 16;
  texture.encoding = sRGBEncoding;

  return (
    <group name="Mountain" ref={group} {...props} dispose={null}>
      <primitive object={nodes.Camera} />
      <mesh
      receiveShadow
      // castShadow
        material={materials.Mountain_glTF}
        geometry={nodes['Mountain_Straight8_(2)'].geometry}
        scale={[1, 1, 1]}
        position={[0, 55.37, 0]}
      />
    </group>
  )
}
